/** Base pathname for system lookup APIs. */
export const SYSTEM_BASE_PATH = '/system';

export const SYSTEM_ENDPOINTS = {
  genders: `${SYSTEM_BASE_PATH}/genders`,
  departments: `${SYSTEM_BASE_PATH}/departments`,
  designations: `${SYSTEM_BASE_PATH}/designations`,
  countries: `${SYSTEM_BASE_PATH}/countries`,
  cities: `${SYSTEM_BASE_PATH}/cities`,
  languages: `${SYSTEM_BASE_PATH}/languages`,
  qualifications: `${SYSTEM_BASE_PATH}/qualifications`,
} as const;
